import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import logoImage from '../logo512.png'; // アプリのロゴ画像をインポート

function SpinningLogo() {
  return (
    <div className="w-24 h-24 flex items-center justify-center">
      <motion.div
        animate={{ 
          rotate: [0, 360, 330, 360, 0, 45, 0],
        }}
        transition={{ 
          duration: 3,
          times: [0, 0.4, 0.5, 0.6, 0.8, 0.9, 1],
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "loop"
        }}
        className="w-20 h-20"
      >
        <img
          src={logoImage}
          alt="Curelity Logo"
          className="w-full h-full object-contain"
        />
      </motion.div>
      
      <motion.div 
        className="absolute w-32 h-32 rounded-full border-4 border-[#C4DDDA] border-opacity-20"
        animate={{
          scale: [0.8, 1, 0.8],
          opacity: [0.4, 0.8, 0.4]
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          repeatType: "reverse"
        }}
      />
    </div>
  );
}

export default function LoadingOverlay({ isVisible, statusMessage }) {
  return (
    <div className={`fixed inset-0 bg-white bg-opacity-80 flex items-center justify-center z-[9999] transition-opacity duration-300 ${isVisible ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}>
      <div className="flex flex-col items-center">
        <SpinningLogo />
        <AnimatePresence mode="wait">
          {statusMessage && (
            <motion.div
              key={statusMessage}
              className="mt-2 py-2 px-4 bg-gray-100 rounded-md"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 10 }}
              transition={{ duration: 0.3 }}
            >
              <p 
                className="text-[#195557] font-bold text-center" 
                style={{ fontFamily: 'Kosugi, sans-serif' }}
                dangerouslySetInnerHTML={{ __html: statusMessage }}
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
} 